import * as React from "react";

import { Customer } from "../../../../domain/model/customer";
import { JobCareer } from "../../../../domain/model/job_career";

import { TJobCareerWithCustomerID } from "../../../../domain/repository/job_career_repository";

import { skillTagConfig } from "src/config/language/ja-JP/domain/model_text";
import styled from "styled-components";
import {
  ConstFontStyle,
  ConstFontWeight,
} from "../../../../config/styles_const/styles_const";
import { ClientBookmark } from "../../../../domain/model/client_bookmark";
import { MultiSkillTag } from "../../../../domain/model/skill_tag";
import FormSelect from "../../../common/atom/form/form_select";
import Paragraph from "../../../common/atom/text/paragraph";
import ParagraphSup from "../../../common/atom/text/paragraph_sup";
import Pagination from "../../../common/molecular/pagination/pagination";
import ScoutCustomerCard from "../../../common/organism/card/scout_customer_card";
import { TPagination } from "../../../type/common";

interface IProps {
  isSearch: boolean;
  customers: Customer[];
  customerCount: number;
  hasSearchQuery: boolean;
  jobCareersWithCustomerID: TJobCareerWithCustomerID[];
  clientBookmarks: ClientBookmark[];
  isLoading: boolean;
  paginationPrams: TPagination;
  handleClickLink: (customer: Customer) => (event: any) => void;
  multiSkillTag: MultiSkillTag | undefined;
  query: string;
}

export const ClientScoutCustomersMain: React.FC<IProps> = (props) => {
  const {
    isSearch,
    customers,
    customerCount,
    hasSearchQuery,
    jobCareersWithCustomerID,
    clientBookmarks,
    paginationPrams,
    handleClickLink,
    multiSkillTag,
    query,
  } = props;

  // customerId: JobCareer[]の連想配列を作成し連携させる。
  const hashJobCareer: { [customerId: string]: JobCareer[] } = {};
  for (const item of jobCareersWithCustomerID) {
    hashJobCareer[item.customerID] = item.jobCareers;
  }

  return (
    <React.Fragment>
      <SearchCountWrapper>
        {isSearch ? (
          <Paragraph icon={'"\f554"'} bold={true}>
            {customerCount}人のエキスパートが見つかりました（検索: {query}）
            {multiSkillTag
              ? `（検索: ${skillTagConfig.multiSkillTagCategoryList.get(
                  multiSkillTag.category
                )} > ${multiSkillTag.name}）`
              : ""}
          </Paragraph>
        ) : (
          <div />
        )}
        {/* {!hasSearchQuery && (
          <SelectOrderByWrapper>
            <SelectOrderByText bold={true}>並び替え</SelectOrderByText>
            <SelectOrderBySelect
              onChange={handleOrderByChange}
              defaultValue={nowOrderBy}
            >
              <option value={OrderBy.OrderBy_CreatedAt_DESC}>
                {customerConfig.orderByList.get(OrderBy.OrderBy_CreatedAt_DESC)}
              </option>
              <option value={OrderBy.OrderBy_Bookmark_DESC}>
                {customerConfig.orderByList.get(OrderBy.OrderBy_Bookmark_DESC)}
              </option>
            </SelectOrderBySelect>
          </SelectOrderByWrapper>
        )} */}
      </SearchCountWrapper>
      {customers.map((customer: Customer, index: number) => {
        const customerId: string = customer.id;
        const jobCareers: JobCareer[] | undefined = hashJobCareer[customerId];
        if (!jobCareers) {
          return null;
        }
        const isBookmarked: boolean = clientBookmarks.some(
          (clientBookmark: ClientBookmark) => {
            return clientBookmark.customerID === customerId;
          }
        );
        return (
          <ScoutCustomerCardWrapper
            key={customerId}
            onClick={handleClickLink(customer)}
          >
            <ScoutCustomerCard
              customer={customer}
              jobCareers={jobCareers}
              isBookmarked={isBookmarked}
              cardURL={`/client/scout/customer/${customerId}`}
            />
          </ScoutCustomerCardWrapper>
        );
      })}
      <Pagination paginationPrams={paginationPrams} />
    </React.Fragment>
  );
};

export default ClientScoutCustomersMain;

const ScoutCustomerCardWrapper = styled.div`
  margin-bottom: 20px;
`;

const SearchCountWrapper = styled.div`
  display: flex;
  justify-content: between-space;
  margin-bottom: 25px;
  justify-content: space-between;
  align-items: center;
`;

const SelectOrderByWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SelectOrderByText = styled(ParagraphSup)`
  white-space: nowrap;
`;

const SelectOrderBySelect = styled(FormSelect)`
  margin-left: 8px;
  padding: 8px 30px 8px 10px;
  font-weight: ${ConstFontWeight.BOLD};
  font-size: ${ConstFontStyle.ParagraphSup.fontSize};
  line-height: ${ConstFontStyle.ParagraphSup.lineHeight};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customers/client_scout_customers_main.tsx